import { Button } from "@/components/ui/button";
import { MessageSquarePlus } from "lucide-react";

interface EmptyStateProps {
  onNewChat: () => void;
  title?: string;
  description?: string;
  buttonLabel?: string;
}

export function EmptyState({
  onNewChat,
  title = "Start a New Chat",
  description = "Select a conversation from the sidebar or start a new one",
  buttonLabel = "New Conversation",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-4 max-w-sm md:max-w-md mx-auto text-center">
      <MessageSquarePlus className="h-16 w-16 text-muted-foreground" />
      <h2 className="text-2xl font-semibold">{title}</h2>
      <p className="text-muted-foreground">{description}</p>
      <Button onClick={onNewChat}>
        <MessageSquarePlus className="mr-2 h-4 w-4" />
        {buttonLabel}
      </Button>
    </div>
  );
}
